
// Enter your Api path 
export const apiPath = window.globalConfig.SigningServiceAPIUrl;

// HMAC token
async function generateHmacHeader() {
    const secret = window.globalConfig.SigningServiceAPIKey;
    const timestamp = Date.now().toString();

    const encoder = new TextEncoder();

    const key = await window.crypto.subtle.importKey(
        "raw",
        encoder.encode(secret),
        { name: "HMAC", hash: "SHA-256" },
        false,
        ["sign"]
    );

    const signatureBuffer = await window.crypto.subtle.sign(
        "HMAC",
        key,
        encoder.encode(timestamp)
    );

    const bytes = new Uint8Array(signatureBuffer);
    let binary = "";
    bytes.forEach(b => binary += String.fromCharCode(b));

    const signature = btoa(binary);

    return `HMAC ${timestamp}:${signature}`;
}
export async function getAuthConfig() {
    const authHeader = await generateHmacHeader();

    return {
        headers: {
            Authorization: authHeader,   
            "Content-Type": "application/json"
        }
    };
}
// Api endpoints with proper data
export const endPoints = {
    getSignerDetailsAndSettings : {endPoint: "/signing/GetSignerDetailsAndSettings"},
    createSigningOrder:{endPoint:"/signing/CreateSigningOrder"},
    callback:{endPoint:"/signing/Callback"},
    getIpAddress:{endPoint:"https://api.ipify.org/?format=json"},
    appLogoApi:{endPoint:"/signing/GetSettings"},
    getDocuments : {endPoint: "/signing/GetDocuments"},
    authenticateSigner : {endPoint: "/signing/AuthenticateEmailAddress"},
    signDocument : {endPoint: "/signing/SigningDocument"},
};


//Norway date time format
export const dateTimeFormat = { dateFormat:"DD.MM.YYYY, HH.mm" , TimeFormat:"HH:mm", dateOnlyFormat: "DD.MM.YYYY"}